(function () {
  'use strict';

  var INIT_KEY = 'checkoutAuthBound';

  function isCustomerLoggedIn() {
    return !!(document.body && document.body.dataset.customerLoggedIn === 'true');
  }

  function customerAccountsEnabled() {
    return !!(document.body && document.body.dataset.customerAccountsEnabled === 'true');
  }

  function shouldGateCheckout() {
    return customerAccountsEnabled() && !isCustomerLoggedIn();
  }

  function getLoginUrl() {
    var checkoutPath = (window.routes && window.routes.checkout_url) || '/checkout';
    return '/account/login?return_url=' + encodeURIComponent(checkoutPath);
  }

  function redirectToLogin(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }
    window.location.assign(getLoginUrl());
    return true;
  }

  function findCheckoutButton(target) {
    if (!target || !target.closest) return null;
    return target.closest(
      '#CartDrawer-Checkout, #checkout, cart-drawer button[name="checkout"], button[name="checkout"], input[name="checkout"]'
    );
  }

  function isCartCheckoutForm(form) {
    if (!form || !form.getAttribute) return false;
    if (form.id === 'CartDrawer-Form' || form.id === 'cart') return true;
    var action = String(form.getAttribute('action') || '');
    return action.indexOf('/cart') !== -1;
  }

  function initCheckoutGate() {
    if (document.documentElement.dataset[INIT_KEY] === 'true') return;
    if (!customerAccountsEnabled()) return;
    document.documentElement.dataset[INIT_KEY] = 'true';

    document.addEventListener(
      'click',
      function (event) {
        if (!shouldGateCheckout()) return;
        var button = findCheckoutButton(event.target);
        if (!button || button.disabled) return;
        redirectToLogin(event);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        if (!shouldGateCheckout()) return;
        var form = event.target;
        if (!isCartCheckoutForm(form)) return;
        var submitter = event.submitter;
        if (!submitter || submitter.name !== 'checkout') return;
        redirectToLogin(event);
      },
      true
    );
  }

  window.kitabooRequireLoginForCheckout = function (event) {
    if (!shouldGateCheckout()) return false;
    return redirectToLogin(event);
  };

  document.addEventListener('DOMContentLoaded', initCheckoutGate);
  document.addEventListener('shopify:section:load', initCheckoutGate);
})();
